import {NgModel} from "@angular/forms";
import {inject, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ActivatedRoute, CanActivateFn, Params, Router, RouterModule, Routes, UrlSegment} from "@angular/router";
import {HomeComponent} from "./pages/home/home.component";
import {AuthService} from "./services/AuthService";
import {isWrappedTsNodeExpr} from "@angular/compiler-cli/src/ngtsc/annotations/common";
import {UnauthorizedComponent} from "./pages/unauthorized/unauthorized.component";
import {PlayerViewComponent} from "./pages/player-view/player-view.component";
import {StaffActivityComponent} from "./pages/staff-activity/staff-activity.component";
import {BoothListComponent} from "./pages/booth-list/booth-list.component";
import {BoothViewComponent} from "./pages/booth-view/booth-view.component";
import {PlayerCreateComponent} from "./pages/player-create/player-create.component";
import {AnnouncesListComponent} from "./pages/announces-list/announces-list.component";
import {CookieService} from "ngx-cookie-service";
import {NotFoundComponent} from "./pages/not-found/not-found.component";
import {ServersComponent} from "./pages/servers/servers.component";
import {APIService} from "./services/APIService";
import {PunishmentsComponent} from "./pages/punishments/punishments.component";
import {RankListComponent} from "./pages/rank-list/rank-list.component";
import {ScheduleComponent} from "./pages/schedule/schedule.component";
import {QuizListComponent} from "./pages/quiz-list/quiz-list.component";
import { ResourcePacksComponent } from "./pages/resource-packs/resource-packs.component";
import {BoothOwnerChangeRequestsComponent} from "./pages/booth-owner-change/booth-owner-change.component";
import { MapImagesComponent } from './pages/map-images/map-images.component';

function convert(snapshot: UrlSegment[], params: Params): string {
  let str = "";
  for(const snap of snapshot) {
    str += snap.path + "/";
  }

  let queryStr = "?";
  for(const key in params) {
    if(key === 'access')
      continue;
    const val = params[key];
    queryStr += key + "=" + val + "&";
  }

  return str.substring(0, str.length - 1) + (queryStr.length > 1 ? queryStr.substring(0, queryStr.length - 1) : "");
}

const canActivateFn: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const apiService = inject(APIService);
  const router = inject(Router);
  if(await authService.checkAuthorized(route)) {
    if('permission' in route.data) {
      const entitled = apiService.hasEntitlement(authService.user!.entitlements, route.data['permission']);
      if(!entitled) {
        await router.navigate(['/unauthorized'], {});
        return false;
      }
    }
    return true;
  }

  await router.navigate(['/unauthorized']);
  return false;
}

const routes: Routes = [
  {path: '', component: HomeComponent, canActivate: [canActivateFn]},
  {path: 'unauthorized', component: UnauthorizedComponent},
  {path: 'login', component: HomeComponent, canActivate: [canActivateFn]},
  {path: 'players', data: {permission: 'MODERATION'}, component: PlayerViewComponent, canActivate: [canActivateFn]},
  {path: 'players/:id', data: {permission: 'MODERATION'}, component: PlayerViewComponent, canActivate: [canActivateFn]},
  {path: 'activity', data: {permission: 'OPERATIONS'}, component: StaffActivityComponent, canActivate: [canActivateFn]},
  {path: 'punishments', data: {permission: 'MODERATION'}, component: PunishmentsComponent, canActivate: [canActivateFn]},
  {path: 'booths/list', data: {permission: 'OPERATIONS'}, component: BoothListComponent, canActivate: [canActivateFn]},
  {path: 'booths/:id', data: {permission: 'OPERATIONS'}, component: BoothViewComponent, canActivate: [canActivateFn]},
  {path: 'create', data: {permission: 'OPERATIONS'}, component: PlayerCreateComponent, canActivate: [canActivateFn]},
  {path: 'schedule', data: {permission: 'OPERATIONS'}, component: ScheduleComponent, canActivate: [canActivateFn]},
  {path: 'announces/list', data: {permission: 'OPERATIONS'}, component: AnnouncesListComponent, canActivate: [canActivateFn]},
  {path: 'servers/list', data: {permission: 'OPERATIONS'}, component: ServersComponent, canActivate: [canActivateFn]},
  {path: 'resources/packs', data: {permission: 'OPERATIONS'}, component: ResourcePacksComponent, canActivate: [canActivateFn]},
  {path: 'resources/map-images', data: {permission: 'OPERATIONS'}, component: MapImagesComponent, canActivate: [canActivateFn]},
  {path: 'booths/owner-change/requests', data: {permission: 'OPERATIONS'}, component: BoothOwnerChangeRequestsComponent, canActivate: [canActivateFn]},
  {path: 'rank/list', data: {permission: 'MODERATION'}, component: RankListComponent, canActivate: [canActivateFn]},
  {path: 'quiz/list', data: {permission: 'OPERATIONS'}, component: QuizListComponent, canActivate: [canActivateFn]},
  {path: '**', component: NotFoundComponent, canActivate: [canActivateFn]}
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
